import Vue from "vue";
import Vuex from "vuex";
import router from "@/router";
import VuexPersistence from "vuex-persist";
import { translateViewRoute } from "@/permission";

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
});
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    router: null,
    menu: null,
  },
  getters: {
    getRouter(state) {
      return state.router;
    },
    getMenu(state) {
      return state.menu;
    },
  },
  mutations: {
    setRouter(state, data) {
      state.router = data;
    },
    setMenu(state, data) {
      state.menu = data;
    },
  },
  actions: {
    // 获取路由
    getRouter({ commit }, data) {
      const _data = translateViewRoute(data, "", []);
      router.addRoutes(_data);
      commit("setRouter", data);
      commit("setMenu", _data);
    },
    // 将转换过的路由添加到页面中
    // getViewRouter({ commit }, data) {
    //   commit("setRouter", data);
    //   // data.forEach(ele => {
    //   //   router.addRoute(ele)
    //   // })
    // },
  },
  modules: {},
  plugins: [vuexLocal.plugin],
});

export default store;
